var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cms 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.75 11V4C22.75 3.271 22.46 2.571 21.945 2.055C21.429 1.54 20.729 1.25 20 1.25C16.168 1.25 7.832 1.25 4 1.25C3.271 1.25 2.571 1.54 2.055 2.055C1.54 2.571 1.25 3.271 1.25 4V20C1.25 20.729 1.54 21.429 2.055 21.945C2.571 22.46 3.271 22.75 4 22.75H11C11.414 22.75 11.75 22.414 11.75 22C11.75 21.586 11.414 21.25 11 21.25C11 21.25 6.652 21.25 4 21.25C3.668 21.25 3.351 21.118 3.116 20.884C2.882 20.649 2.75 20.332 2.75 20V4C2.75 3.668 2.882 3.351 3.116 3.116C3.351 2.882 3.668 2.75 4 2.75H20C20.332 2.75 20.649 2.882 20.884 3.116C21.118 3.351 21.25 3.668 21.25 4V11C21.25 11.414 21.586 11.75 22 11.75C22.414 11.75 22.75 11.414 22.75 11Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7.75H22C22.414 7.75 22.75 7.414 22.75 7C22.75 6.586 22.414 6.25 22 6.25H2C1.586 6.25 1.25 6.586 1.25 7C1.25 7.414 1.586 7.75 2 7.75Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 5.25H5.5C5.914 5.25 6.25 4.914 6.25 4.5C6.25 4.086 5.914 3.75 5.5 3.75H4.5C4.086 3.75 3.75 4.086 3.75 4.5C3.75 4.914 4.086 5.25 4.5 5.25Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5.25H9C9.414 5.25 9.75 4.914 9.75 4.5C9.75 4.086 9.414 3.75 9 3.75H8C7.586 3.75 7.25 4.086 7.25 4.5C7.25 4.914 7.586 5.25 8 5.25Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 5.25H12.5C12.914 5.25 13.25 4.914 13.25 4.5C13.25 4.086 12.914 3.75 12.5 3.75H11.5C11.086 3.75 10.75 4.086 10.75 4.5C10.75 4.914 11.086 5.25 11.5 5.25Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 13.25C14.93 13.25 13.25 14.93 13.25 17C13.25 19.07 14.93 20.75 17 20.75C19.07 20.75 20.75 19.07 20.75 17C20.75 14.93 19.07 13.25 17 13.25ZM17 14.75C18.242 14.75 19.25 15.758 19.25 17C19.25 18.242 18.242 19.25 17 19.25C15.758 19.25 14.75 18.242 14.75 17C14.75 15.758 15.758 14.75 17 14.75Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 17.75H22C22.414 17.75 22.75 17.414 22.75 17C22.75 16.586 22.414 16.25 22 16.25H20C19.586 16.25 19.25 16.586 19.25 17C19.25 17.414 19.586 17.75 20 17.75Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6518 15.409L21.0658 13.995C21.3588 13.702 21.3588 13.227 21.0658 12.934C20.7728 12.641 20.2978 12.641 20.0048 12.934L18.5908 14.348C18.2978 14.641 18.2978 15.116 18.5908 15.409C18.8838 15.702 19.3588 15.702 19.6518 15.409Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.75 14V12C17.75 11.586 17.414 11.25 17 11.25C16.586 11.25 16.25 11.586 16.25 12V14C16.25 14.414 16.586 14.75 17 14.75C17.414 14.75 17.75 14.414 17.75 14Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4091 14.348L13.9951 12.934C13.7021 12.641 13.2271 12.641 12.9341 12.934C12.6411 13.227 12.6411 13.702 12.9341 13.995L14.3481 15.409C14.6411 15.702 15.1161 15.702 15.4091 15.409C15.7021 15.116 15.7021 14.641 15.4091 14.348Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 16.25H12C11.586 16.25 11.25 16.586 11.25 17C11.25 17.414 11.586 17.75 12 17.75H14C14.414 17.75 14.75 17.414 14.75 17C14.75 16.586 14.414 16.25 14 16.25Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3481 18.591L12.9341 20.005C12.6411 20.298 12.6411 20.773 12.9341 21.066C13.2271 21.359 13.7021 21.359 13.9951 21.066L15.4091 19.652C15.7021 19.359 15.7021 18.884 15.4091 18.591C15.1161 18.298 14.6411 18.298 14.3481 18.591Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 20V22C16.25 22.414 16.586 22.75 17 22.75C17.414 22.75 17.75 22.414 17.75 22V20C17.75 19.586 17.414 19.25 17 19.25C16.586 19.25 16.25 19.586 16.25 20Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5908 19.652L20.0048 21.066C20.2978 21.359 20.7728 21.359 21.0658 21.066C21.3588 20.773 21.3588 20.298 21.0658 20.005L19.6518 18.591C19.3588 18.298 18.8838 18.298 18.5908 18.591C18.2978 18.884 18.2978 19.359 18.5908 19.652Z",
    fill: "#1D2939"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.7799e041df8c153dfbd213a41a43121b.svg";
export { ForwardRef as ReactComponent };